<template>
  <div class="iha-detail-page page-wrapper">
    <div class="container-fluid">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <b-button class="back-button d-flex align-items-center gap-2" @click="goBack">
          <span class="icon-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
              <path fill="currentColor" d="m7.825 13l5.6 5.6L12 20l-8-8l8-8l1.425 1.4l-5.6 5.6H20v2z" />
            </svg>
          </span>
          Back to Issues
        </b-button>
      </div>
      <div class="row">
        <div class="col-lg-8 mb-3 mb-lg-0">
          <div class="d-flex flex-column gap-3">
            <div class="iha-card-container d-flex flex-column gap-3">
              <div class="user-info-container d-flex justify-content-between align-items-start gap-2 flex-wrap">
                <div class="left-content">
                  <div class="d-flex align-items-center gap-2 flex-wrap">
                    <h4 class="user-name m-0">
                      {{ issue?.member?.cfname }} {{ issue?.member?.cmname || '' }} {{ issue?.member?.clname }}
                    </h4>
                    <span class="status-badge-issue" :class="issue.status">
                      {{ issue?.status }}
                    </span>
                    <span class="status-badge-issue issue-type" :class="issue.type">{{ issue?.type }}</span>
                  </div>
                  <div class="user-email">
                    {{ issue?.email }}
                  </div>
                </div>
                <div class="right-content">
                  <button class="withdraw-btn-outline d-flex align-items-center gap-2" @click="openWithdrawModal"
                    v-if="issue.status === 'pending'">
                    <span class="icon-wrap">
                      <i class="fas fa-ban"></i>
                    </span>
                    Withdraw
                  </button>
                </div>
              </div>
              <div class="iha-issue-info d-flex gap-3 flex-wrap">
                <div class="info-item d-flex gap-2">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2">
                        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                        <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2M9 9h1m-1 4h6m-6 4h6" />
                      </g>
                    </svg>
                  </span>
                  <div class="info-content">
                    <div class="title">Plan</div>
                    <div class="info-text">{{ issue?.plan || '-' }}</div>
                  </div>
                </div>
                <div class="info-item d-flex gap-2">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                      <path fill="currentColor"
                        d="M19 4h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7h16Zm0-9H4V7a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V6h6v1a1 1 0 0 0 2 0V6h2a1 1 0 0 1 1 1Z" />
                    </svg>
                  </span>
                  <div class="info-content">
                    <div class="title">Submitted On</div>
                    <div class="info-text">{{ issue?.submittedOn || '-' }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Description -->
            <div class="iha-card-maincontainer">
              <div class="heading-section d-flex align-items-center">
                <div class="icon-wrapper d-flex align-items-center justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2">
                      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2M9 9h1m-1 4h6m-6 4h6" />
                    </g>
                  </svg>
                </div>
                <div class="title">Description</div>
              </div>
              <div class="body-container d-flex flex-column">
                <div class="desc-container">
                  {{ issue?.description || '-' }}
                </div>
                <div class="attached_container" v-if="documents && documents.length > 0">
                  <div class="attach_title">Attached Files ({{ documents.length }})</div>
                  <div class="file_list d-flex gap-2 flex-wrap">
                    <div class="file_list-item" v-for="doc in documents" :key="doc.id" @click="previewFile(doc)"
                      style="cursor: pointer;" :title="doc.original_file_name">
                      <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
                          <path fill="currentColor" fill-rule="evenodd"
                            d="M175.541 451.418c-34.837 0-67.605-13.568-92.245-38.208c-50.859-50.859-50.859-133.632 0-184.49L257.269 54.745l27.158 27.179l-173.974 173.952c-35.882 35.904-35.882 94.293 0 130.176c17.387 17.386 40.512 26.965 65.088 26.965s47.702-9.579 65.088-26.965l172.118-172.118c21.397-21.397 21.397-56.192 0-77.589c-20.736-20.757-56.896-20.693-77.59-.021L166.603 304.75c-3.542 3.542-5.483 8.256-5.483 13.27s1.941 9.728 5.504 13.269c7.083 7.147 19.477 7.104 26.56 0l141.504-141.483l27.157 27.179l-141.482 141.483c-22.336 22.293-58.603 22.25-80.896 0c-22.294-22.294-22.294-58.603 0-80.875L308.02 109.189c17.579-17.6 41.024-27.307 65.942-27.307c24.896 0 48.32 9.685 65.962 27.307c36.352 36.373 36.352 95.552 0 131.925L267.787 413.21c-24.64 24.64-57.387 38.208-92.246 38.208" />
                        </svg>
                      </span>
                      {{ truncateFilename(doc.original_file_name) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Conversation -->
            <div class="iha-card-maincontainer">
              <div class="heading-section d-flex align-items-center">
                <div class="icon-wrapper d-flex align-items-center justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2"
                      d="m5.6 19.92l1.524-1.219l.01-.008c.318-.255.479-.383.658-.474q.241-.123.508-.178C8.499 18 8.706 18 9.122 18h8.681c1.118 0 1.678 0 2.105-.218a2 2 0 0 0 .874-.874C21 16.48 21 15.92 21 14.804V7.197c0-1.118 0-1.678-.218-2.105a2 2 0 0 0-.875-.874C19.48 4 18.92 4 17.8 4H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 5.52 3 6.08 3 7.2v11.471c0 1.066 0 1.599.218 1.872a1 1 0 0 0 .783.377c.35 0 .766-.334 1.599-1" />
                  </svg>
                </div>
                <div class="title">Conversation</div>
              </div>
              <div class="body-container d-flex flex-column">
                <div class="messages">

                  <template v-if="messages.length">

                    <div v-for="msg in messages" :key="msg.id" :class="['message-row', msg.role]">
                      <div v-if="msg.role === 'admin'" class="avatar">
                        {{ getInitial(msg.name) }}
                      </div>

                      <div class="message-bubble">
                        <div class="message-header">
                          <span class="name">{{ msg.name }}</span>
                          <span class="time">{{ msg.time }}</span>
                        </div>

                        <p class="message-text">
                          {{ msg.text }}
                        </p>
                        
                        <div v-if="msg.document && msg.document.length > 0" class="message-documents mt-2 d-flex flex-wrap gap-2">
                          <div class="file_list-item" v-for="doc in msg.document" :key="doc.id" @click="previewFile(doc)"
                            style="cursor: pointer; padding: 4px 8px; border-radius: 4px; font-size: 12px; background: #eaeff5; max-width: 180px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-flex; align-items: center;" :title="doc.original_file_name">
                            <span class="icon" style="color: #6c757d; margin-right: 4px;">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512">
                                <path fill="currentColor" fill-rule="evenodd"
                                  d="M175.541 451.418c-34.837 0-67.605-13.568-92.245-38.208c-50.859-50.859-50.859-133.632 0-184.49L257.269 54.745l27.158 27.179l-173.974 173.952c-35.882 35.904-35.882 94.293 0 130.176c17.387 17.386 40.512 26.965 65.088 26.965s47.702-9.579 65.088-26.965l172.118-172.118c21.397-21.397 21.397-56.192 0-77.589c-20.736-20.757-56.896-20.693-77.59-.021L166.603 304.75c-3.542 3.542-5.483 8.256-5.483 13.27s1.941 9.728 5.504 13.269c7.083 7.147 19.477 7.104 26.56 0l141.504-141.483l27.157 27.179l-141.482 141.483c-22.336 22.293-58.603 22.25-80.896 0c-22.294-22.294-22.294-58.603 0-80.875L308.02 109.189c17.579-17.6 41.024-27.307 65.942-27.307c24.896 0 48.32 9.685 65.962 27.307c36.352 36.373 36.352 95.552 0 131.925L267.787 413.21c-24.64 24.64-57.387 38.208-92.246 38.208" />
                              </svg>
                            </span>
                            {{ truncateFilename(doc.original_file_name) }}
                          </div>
                        </div>
                      </div>

                      <div v-if="msg.role === 'user'" class="avatar">
                        {{ getInitial(msg.name) }}
                      </div>

                    </div>

                  </template>

                  <div v-else class="no-conversation flex-column">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="2"
                          d="m5.6 19.92l1.524-1.219l.01-.008c.318-.255.479-.383.658-.474q.241-.123.508-.178C8.499 18 8.706 18 9.122 18h8.681c1.118 0 1.678 0 2.105-.218a2 2 0 0 0 .874-.874C21 16.48 21 15.92 21 14.804V7.197c0-1.118 0-1.678-.218-2.105a2 2 0 0 0-.875-.874C19.48 4 18.92 4 17.8 4H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 5.52 3 6.08 3 7.2v11.471c0 1.066 0 1.599.218 1.872a1 1 0 0 0 .783.377c.35 0 .766-.334 1.599-1" />
                      </svg>
                    </div>
                    <div class="content-wrap d-flex flex-column gap-0 align-items-center">

                      <div class="title">
                        No messages yet
                      </div>
                      <div class="sm-text">
                        Our team will reply here once reviewed.
                      </div>
                    </div>
                  </div>

                </div>
                <div v-if="isConversationDisabled" class="conversation-closed-notice">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"/>
                  </svg>
                  <span>Conversation is <strong>{{ issue.status }}</strong>. Replies are no longer accepted for this issue.</span>
                </div>

                <div v-else class="reply-box">

                  <textarea v-model="reply" placeholder="Type your message ...."></textarea>

                  <div class="reply-footer d-flex justify-content-between align-items-center flex-wrap">
                    <div class="d-flex align-items-center">
                      <span class="attachment" style="cursor: pointer;" @click="$refs.commentFile.click()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
                          <path fill="currentColor" fill-rule="evenodd"
                            d="M175.541 451.418c-34.837 0-67.605-13.568-92.245-38.208c-50.859-50.859-50.859-133.632 0-184.49L257.269 54.745l27.158 27.179l-173.974 173.952c-35.882 35.904-35.882 94.293 0 130.176c17.387 17.386 40.512 26.965 65.088 26.965s47.702-9.579 65.088-26.965l172.118-172.118c21.397-21.397 21.397-56.192 0-77.589c-20.736-20.757-56.896-20.693-77.59-.021L166.603 304.75c-3.542 3.542-5.483 8.256-5.483 13.27s1.941 9.728 5.504 13.269c7.083 7.147 19.477 7.104 26.56 0l141.504-141.483l27.157 27.179l-141.482 141.483c-22.336 22.293-58.603 22.25-80.896 0c-22.294-22.294-22.294-58.603 0-80.875L308.02 109.189c17.579-17.6 41.024-27.307 65.942-27.307c24.896 0 48.32 9.685 65.962 27.307c36.352 36.373 36.352 95.552 0 131.925L267.787 413.21c-24.64 24.64-57.387 38.208-92.246 38.208" />
                        </svg><span>

                        </span> Add Attachment
                      </span>
                      <input type="file" ref="commentFile" style="display: none;" @change="handleFileChange" />
                      <span v-if="commentFile" class="ms-2 text-truncate" style="max-width: 150px; font-size: 14px;">{{ commentFile.name }} <i class="fas fa-times text-danger ms-1" style="cursor:pointer;" @click="commentFile = null"></i></span>
                      <span class="ms-2" style="font-size: 12px; color: #6c757d;">Max file size: 5 MB</span>
                    </div>

                    <button class="send-btn univ-btn d-flex align-items-center justify-content-center gap-2 m-0" @click="sendReply" :disabled="isSendingReply">
                      <span v-if="isSendingReply" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      {{ isSendingReply ? 'Sending...' : 'Send Reply' }}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Status History -->
        <div class="col-lg-4">
          <div class="iha-card-maincontainer">
            <div class="heading-section d-flex align-items-center">
              <div class="icon-wrapper d-flex align-items-center justify-content-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M12 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m0-18a10 10 0 0 1 10 10a10 10 0 0 1-10 10C6.47 22 2 17.5 2 12A10 10 0 0 1 12 2m.5 5v5.25l4.5 2.67l-.75 1.23L11 13V7z" />
                </svg>
              </div>
              <div class="title">Status History</div>
            </div>
            <div class="body-container d-flex flex-column">
              <div class="status-history-container d-flex flex-column gap-3">
                <div class="status_history-item" v-for="history in statusHistories" :key="history.id">
                  <div class="dot"></div>

                  <div class="history-content">
                    <div class="history-status" v-if="!history.old_status">
                      Issue created with status <span class="fw-semibold">
                        {{ getIssueStatusLabel(history.new_status) }}
                      </span>
                    </div>
                    <div class="history-status" v-else>
                      Status changed from <span class="fw-semibold">
                        {{ getIssueStatusLabel(history.old_status) }}
                      </span> to <span class="fw-semibold">
                        {{ getIssueStatusLabel(history.new_status) }}
                      </span>
                    </div>
                    <div class="d-flex gap-2 flex-wrap info-text align-items-center">
                      <div class="user-name">
                        {{ history.agent_name }}
                      </div>
                      <div class="dot-sm"></div>
                      <div class="status-time">
                        {{ formatDateTime(history.created_at) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <WithdrawIssueModal v-if="showWithdrawIssueModal" :row="issue" @close="showWithdrawIssueModal = false"
      @withdraw="handleWithdraw" />

    <b-modal v-model="previewModalVisible" size="xl" centered hide-footer hide-header-close
      modal-class="attachment-preview-modal" content-class="attachment-preview-content"
      body-class="attachment-preview-body">
      <template #modal-header>
        <div class="attachment-preview-header align-items-end justify-content-end w-100 d-flex mb-3">
          <b-button variant="close-btn" class="btn-container" @click="closePreviewModal">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>

      <div v-if="previewFileItem" class="attachment-preview-shell">
        <img v-if="isImage(previewFileItem)" :src="previewFileItem?.full_file_url ? previewFileItem.full_file_url : previewFileItem.url" :alt="previewFileItem.original_file_name"
          class="attachment-preview-image" />

        <iframe v-else-if="isPdf(previewFileItem)" :src="previewFileItem?.full_file_url ? previewFileItem.full_file_url : previewFileItem.url" class="attachment-preview-pdf"
          frameborder="0" :title="previewFileItem.original_file_name"></iframe>
      </div>
    </b-modal>
  </div>
</template>

<script>
import "./IhaIssue.css";
import axios from "axios";
import Helper from "@/resource/Helper";
import WithdrawIssueModal from "./WithdrawIssueModal.vue";

export default {
  components: {
    WithdrawIssueModal,
  },

  props: ["id"],

  computed: {
    isConversationDisabled() {
      return this.issue.status === 'resolved' || this.issue.status === 'withdrawn';
    },
  },

  data() {
    return {
      issue: {},
      documents: [],
      statusHistories: [],
      previewModalVisible: false,
      previewFileItem: null,
      reply: "",
      commentFile: null,
      showWithdrawIssueModal: false,
      isSendingReply: false,
      messages: []
    };
  },

  mounted() {
    this.loadIssue();
    this.loadDocuments();
    this.loadStatusHistory();
    this.loadComments();
  },

  methods: {
    truncateFilename(name, maxLen = 24) {
      if (!name || name.length <= maxLen) return name;
      const dotIndex = name.lastIndexOf('.');
      const ext = dotIndex !== -1 ? name.slice(dotIndex) : '';
      const base = dotIndex !== -1 ? name.slice(0, dotIndex) : name;
      const available = maxLen - ext.length - 3;
      if (available <= 2) return name.slice(0, maxLen - 3) + '...';
      const front = Math.ceil(available / 2);
      const back = Math.floor(available / 2);
      return base.slice(0, front) + '...' + base.slice(-back) + ext;
    },

    handleFileChange(event) {
      if (event.target.files.length > 0) {
        this.commentFile = event.target.files[0];
      }
    },

    async sendReply() {
      if (!this.reply.trim() && !this.commentFile) return;
      if (this.isSendingReply) return;

      this.isSendingReply = true;
      try {
        const issueId = this.id || this.$route.params.id;
        const apiUrl = `${process.env.VUE_APP_TICKETING_URL_API}v2/iha/submit-comment`;

        const formData = new FormData();
        formData.append("issue_id", issueId);
        formData.append("type", "agent");
        if (this.reply.trim()) {
            formData.append("comment", this.reply);
        } else {
            formData.append("comment", "Sent an attachment");
        }
        formData.append("agent_id", this.$store.state.Auth.rep.id);

        if (this.commentFile) {
          formData.append("comment_document[0]", this.commentFile);
        }

        const response = await axios.post(apiUrl, formData, {
          headers: {
            'X-Ticketing-Token': Helper.ticketingToken(),
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.data.success) {
          
          this.reply = "";
          this.commentFile = null;
          if (this.$refs.commentFile) {
            this.$refs.commentFile.value = null;
          }
          
          await this.loadComments();
        }
      } catch (error) {
        this.$toast.error(error?.response?.data?.message || "Failed to submit comment.");
        console.error("Error submitting comment:", error);
      } finally {
        this.isSendingReply = false;
      }
    },

    getInitial(name) {
      if (!name) return "";
      return name
        .split(" ")
        .map(n => n[0])
        .join("")
        .toUpperCase();
    },

    getIssueStatus(statusId) {
      const statusMap = {
        4: 'pending',
        5: 'withdrawn',
        6: 'seen',
        7: 'progress',
        8: 'resolved'
      };
      return statusMap[statusId] || 'Unknown';
    },

    getIssueStatusLabel(statusId) {
      const statusMap = {
        4: 'Pending',
        5: 'Withdrawn',
        6: 'Seen',
        7: 'In Progress',
        8: 'Resolved'
      };
      return statusMap[statusId] || 'Unknown';
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${month}/${day}/${year}`;
    },

    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const dateFormatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      const timeFormatter = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
      return `${dateFormatter.format(date)} at ${timeFormatter.format(date)}`;
    },

    async loadIssue() {
      try {
        const issueId = this.id || this.$route.params.id;
        if (!issueId) return;

        const apiUrl = `${process.env.VUE_APP_TICKETING_URL_API}v2/iha/issue-details/${issueId}`;
        const response = await axios.get(apiUrl, {
          headers: {
            'X-Ticketing-Token': Helper.ticketingToken(),
          },
        });

        if (!response.data?.data || response.data.data.length === 0) {
          this.$toast.error("Issue details not found.");
          return;
        }

        const data = response.data.data[0];

        this.issue = {
          id: data.issue?.id,
          member: data.member_details,
          email: data.member_details ? data.member_details.cemail : '-',
          plan: data.plan_details ? data.plan_details.web_display_name : '-',
          type: data.issue?.type,
          description: data.issue?.details,
          status: data.issue ? this.getIssueStatus(data.issue.status) : '-',
          submittedOn: data.issue ? this.formatDate(data.issue.created_at) : '-',
        };

      } catch (error) {
        this.$toast.error(error?.response?.data?.message || "Failed to fetch issue details.");
        console.error("Error fetching issue details:", error);
      }
    },

    async loadDocuments() {
      try {
        const issueId = this.id || this.$route.params.id;
        if (!issueId) return;

        const apiUrl = `${process.env.VUE_APP_TICKETING_URL_API}v2/iha/issues/${issueId}/documents`;
        const response = await axios.get(apiUrl, {
          headers: {
            'X-Ticketing-Token': Helper.ticketingToken(),
          },
        });

        if (response.data?.data?.data) {
          this.documents = response.data.data.data;
        } else {
          this.documents = [];
        }
      } catch (error) {
        console.error("Error fetching issue documents:", error);
      }
    },

    async loadStatusHistory() {
      try {
        const issueId = this.id || this.$route.params.id;
        if (!issueId) return;

        const apiUrl = `${process.env.VUE_APP_TICKETING_URL_API}v2/iha/issues/${issueId}/status-history`;
        const response = await axios.get(apiUrl, {
          headers: {
            'X-Ticketing-Token': Helper.ticketingToken(),
          },
        });

        if (response.data?.data) {
          this.statusHistories = response.data.data;
        } else {
          this.statusHistories = [];
        }
      } catch (error) {
        console.error("Error fetching status history:", error);
      }
    },

    async loadComments() {
      try {
        const issueId = this.id || this.$route.params.id;
        if (!issueId) return;

        const apiUrl = `${process.env.VUE_APP_TICKETING_URL_API}v2/iha/issues/${issueId}/comments`;
        const response = await axios.get(apiUrl, {
          headers: {
            'X-Ticketing-Token': Helper.ticketingToken(),
          },
        });

        if (response.data?.data?.data) {
          // Map to correct chat bubble properties
          this.messages = response.data.data.data.map((c) => {
            const isAgent = Boolean(c.commented_by?.type && c.commented_by.type.toLowerCase() === 'agent');
            return {
              id: c.id,
              role: isAgent ? 'user' : 'admin',
              name: c.commented_by?.name || 'Unknown',
              time: this.formatDateTime(c.created_at),
              text: c.comment,
              document: c.document || []
            };
          }).reverse(); // Optional: Reverse so oldest is on top, depending on API order. Usually UI sorts oldest -> newest top to bottom.
        } else {
          this.messages = [];
        }
      } catch (error) {
        console.error("Error fetching comments:", error);
      }
    },

    goBack() {
      this.$router.push("/iha-issues");
    },

    openWithdrawModal() {
      this.showWithdrawIssueModal = true;
    },

    isPdf(file) {
      if (!file || !file.original_file_name) return false;
      return file.original_file_name.toLowerCase().endsWith(".pdf");
    },

    isImage(file) {
      if (!file || !file.original_file_name) return false;
      return [".png", ".jpg", ".jpeg"].some((ext) => file.original_file_name.toLowerCase().endsWith(ext));
    },

    previewFile(file) {
      this.previewFileItem = file;
      this.previewModalVisible = true;
    },

    closePreviewModal() {
      this.previewModalVisible = false;
      this.previewFileItem = null;
    },

    async handleWithdraw(issueId) {
      try {
        const apiUrl = `${process.env.VUE_APP_TICKETING_URL_API}v2/agent/issues/change-status`;
        await axios.post(apiUrl, {
          id: issueId,
          status: 5, // 5 for withdrawn
          agent_id: this.$store.state.Auth.rep.id,
        }, {
          headers: {
            'X-Ticketing-Token': Helper.ticketingToken(),
          },
        });
        this.$toast.success("The issue has been withdrawn successfully.");
        this.showWithdrawIssueModal = false;
        this.loadIssue();
      } catch (error) {
        this.$toast.error(error?.response?.data?.message || "Failed to withdraw issue.");
        console.error("Error withdrawing issue:", error);
      }
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
}

.badge {
  font-size: 14px;
  padding: 6px 10px;
}

.conversation-closed-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  color: #6c757d;
  font-size: 14px;
  margin-top: 12px;
}

.conversation-closed-notice strong {
  text-transform: capitalize;
}
</style>
